module.exports = __webpack_public_path__ + "static/11th-b7b5b6cff107339c5585dc9aa310af3c.png";